import { api } from "@/lib/api";

const keyFor = (slug) => `business.public_customer_session.${slug}`;

export function getStoredPublicCustomerSession(slug) {
  try { return JSON.parse(localStorage.getItem(keyFor(slug)) || "null"); } catch { return null; }
}

function storePublicCustomerSession(slug, session) {
  localStorage.setItem(keyFor(slug), JSON.stringify(session));
  return session;
}

/** Creates or resumes the device-scoped server session used for My Order and History. */
export async function getOrCreatePublicCustomerSession(slug) {
  const current = getStoredPublicCustomerSession(slug);
  return storePublicCustomerSession(slug, await api.createPublicCustomerSession(slug, current?.id));
}

export async function savePublicCustomerDetails(slug, details) {
  const session = await getOrCreatePublicCustomerSession(slug);
  return storePublicCustomerSession(slug, await api.savePublicCustomerSession(slug, session.id, details));
}

export async function activatePublicCustomerSession(slug, details) {
  const session = await getOrCreatePublicCustomerSession(slug);
  return storePublicCustomerSession(slug, await api.activatePublicCustomerSession(slug, session.id, details));
}

export async function rotatePublicCustomerSession(slug) {
  return storePublicCustomerSession(slug, await api.rotatePublicCustomerSession(slug));
}
